import {
  PACKING_LIST_PAGE_SIZES,
  type PackingListPageSize
} from '@/components/stickers/packing-list-document'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface PageSizeToggleProps {
  value: PackingListPageSize
  onChange: (size: PackingListPageSize) => void
  disabled?: boolean
}

/** The browser can't read the printer's paper, so the size is picked here before printing. */
export const PageSizeToggle = ({ value, onChange, disabled = false }: PageSizeToggleProps) => (
  <div className='flex items-center gap-1 rounded-md border p-0.5'>
    {PACKING_LIST_PAGE_SIZES.map((size) => (
      <Button
        key={size.value}
        type='button'
        variant='ghost'
        size='sm'
        aria-pressed={value === size.value}
        disabled={disabled}
        className={cn('h-8 px-2.5 text-xs', value === size.value && 'bg-grey-200')}
        onClick={() => onChange(size.value)}
      >
        {size.label}
      </Button>
    ))}
  </div>
)
